import React, { useCallback, useEffect, useState } from 'react';
import MultiRangeSlider from '../forms/MultiRangeSlider';
import useOuterClick from '../../../hooks/useOuterClick';

const MinMaxSlider = ({keyName, title, min, max, handleParams, params, step, formatter, unit }) => {

	const [current, setCurrent] = useState({min:null, max: null})
	const [open, setOpen] = useState(false)
	const [active, setActive] = useState(false)
	const [currentTitle, setCurrentTitle] = useState('Välj ' + title)
	const innerRef = useOuterClick( e => {
		setOpen(false)
	})
	const calcedMin = Math.floor( min/step ) * step;
	const calcedMax = Math.ceil( max/step ) * step;

	const formatterCaller = useCallback((val) => {
		if(!val || val === '') {
			return ''
		}

		if( typeof formatter === "function") {
			return formatter(val)
		} else {
			return val
		}
	},[formatter])

	const handleCallback = ({valueMin, valueMax}) => {
		const newParams = new URLSearchParams( params.toString() )
		newParams.set(`${keyName}Max`, valueMax);
		newParams.set(`${keyName}Min`, valueMin);

		let stillActive = 2
		if(valueMax >= max) {
			newParams.delete(`${keyName}Max`);
			stillActive--
		}
		if(valueMin <= min) {
			newParams.delete(`${keyName}Min`);
			stillActive--
		}

		if(stillActive === 0 ) {
			setActive(false)
		}
		handleParams(newParams)
	}

	useEffect(()=>{
		let newMax;
		let newMin;

		if(params.get(`${keyName}Max`) !== null && params.get(`${keyName}Max`) !== current.max) {
			newMax = Math.min(params.get(`${keyName}Max`),max)
		}
		if(params.get(`${keyName}Min`) !== null && params.get(`${keyName}Min`) !== current.min) {
			newMin = Math.max(params.get(`${keyName}Min`), min)
		}

		const newCurrent = {};

		if([newMin, newMax].join('').length > 0 ) {
			setActive(true)
			setCurrent(Object.assign(current, { min: newMin ?? current.min, max: newMax ?? current.max }))
			setCurrentTitle([formatterCaller(newMin), formatterCaller(newMax)].join(' - '))
		} else {
			setActive(false)
			setCurrent(Object.assign(current, { min: calcedMin, max: calcedMax }))
			setCurrentTitle('Välj ' + title)
		}
	},[params])


	const headingStyle = {    
		position: 'relative',
		padding: '0 var(--rmsc-p)',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		height: 'var(--rmsc-h)',
		cursor: 'default',
		outline: '0',
		boxSizing: 'border-box'
	}
	const headingValueStyle = {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		boxSizing: 'border-box',
		flex: '1',
		color: active ? '#fff':'var(--rmsc-gray)'
	}
	
	const contentStyle = {
		position: 'absolute',
		left: '0',
		right: '0',
		margin: '0 .5rem',
		zIndex: '99',
		padding: '1rem'
	}

	const greyStyle = {
		boxSizing: 'border-box',
		color: 'var(--rmsc-gray)'
	}

	const svgStyle = {
		fill: "none",
		stroke: active ? '#fff':'var(--rmsc-gray)', //"currentColor",
		strokeWidth: "2"
	}

	
	const currentStyle = {
		boxSizing: 'border-box',
	}
	return (
		<div className={`multiselect-container${active ? ' active':''}`}>
			<label>{title}</label>
			<div className="multi-select">
				<div ref={innerRef} tabIndex="0" className="dropdown-container" aria-labelledby={title} aria-readonly="true" aria-expanded={open} onClick={ () => { setOpen(!open) } }>
					<div className="dropdown-heading" style={headingStyle}>
						<div className="dropdown-heading-value" style={headingValueStyle}>
							{
								active 
									? <span style={currentStyle}>{currentTitle}</span>
									: <span className="gray" style={greyStyle}>{currentTitle}</span>
							}
							
						</div>
						<svg width="24" height="24" style={svgStyle} className="dropdown-heading-dropdown-arrow gray"><path d="M6 9L12 15 18 9"></path></svg>
					</div>
					{ open &&
						<div className="dropdown-content" style={contentStyle}>
							<label>{title}</label>
							<MultiRangeSlider min={calcedMin} max={calcedMax} step={step} current={current} callback={handleCallback} valueFormatter={formatter} unit={unit} />
						</div>
					}
				</div>
			</div>
		</div>
	)
}

export default MinMaxSlider;